/* crochetbylot — theme.js */
(function () {
  "use strict";

const money = (cents) => {
    const fmt = window.themeMoneyFormat || "€{{amount}}";
    function fmtNum(num, precision, thousands, decimal) {
      if (isNaN(num) || num == null) return "0";
      const n = (num / 100).toFixed(precision);
      const parts = n.split(".");
      const whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands);
      const dec = parts[1] ? decimal + parts[1] : "";
      return whole + dec;
    }
    const m = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    if (!m) return fmt;
    let v;
    switch (m[1]) {
      case "amount": v = fmtNum(cents, 2, ",", "."); break;
      case "amount_no_decimals": v = fmtNum(cents, 0, ",", "."); break;
      case "amount_with_comma_separator": v = fmtNum(cents, 2, ".", ","); break;
      case "amount_no_decimals_with_comma_separator": v = fmtNum(cents, 0, ".", ","); break;
      case "amount_with_apostrophe_separator": v = fmtNum(cents, 2, "'", "."); break;
      case "amount_with_space_separator": v = fmtNum(cents, 2, " ", ","); break;
      case "amount_no_decimals_with_space_separator": v = fmtNum(cents, 0, " ", ""); break;
      default: v = fmtNum(cents, 2, ",", ".");
    }
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, v);
  };

  /* ---------- Generic open/close helpers ---------- */
  function bindToggle(openSelector, panelSelector, overlaySelector) {
    const panel = document.querySelector(panelSelector);
    const overlay = overlaySelector ? document.querySelector(overlaySelector) : null;
    if (!panel) return null;
    const open = () => {
      panel.dataset.open = "true";
      if (overlay) overlay.dataset.open = "true";
      document.body.style.overflow = "hidden";
      const f = panel.querySelector("a,button,input");
      if (f) f.focus();
    };
    const close = () => {
      panel.dataset.open = "false";
      if (overlay) overlay.dataset.open = "false";
      document.body.style.overflow = "";
    };
    document.querySelectorAll(openSelector).forEach((b) => b.addEventListener("click", open));
    panel.querySelectorAll("[data-close]").forEach((b) => b.addEventListener("click", close));
    if (overlay) overlay.addEventListener("click", close);
    document.addEventListener("keydown", (e) => { if (e.key === "Escape") close(); });
    return { open, close };
  }

  const mobileNav = bindToggle("[data-menu-open]", ".mobile-nav", ".nav-overlay");
  const cartDrawer = bindToggle("[data-cart-open]", ".drawer", ".drawer-overlay");

 /* ---------- Cart ---------- */
  const escapeHtml = (s) => String(s).replace(/[&<>"']/g, (c) => (
    { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]
  ));

  function renderProperties(props) {
    if (!props) return "";
    return Object.entries(props)
      .filter(([k, v]) => k && k.charAt(0) !== "_" && v !== null && v !== "")
      .map(([k, v]) => `<div class="cart-line__variant">${escapeHtml(k)}: ${escapeHtml(v)}</div>`)
      .join("");
  }

  function renderCart(cart) {
    const body = document.querySelector("[data-cart-body]");
    const foot = document.querySelector("[data-cart-foot]");
    const counts = document.querySelectorAll("[data-cart-count]");
    counts.forEach((c) => {
      c.textContent = cart.item_count;
      c.hidden = cart.item_count === 0;
    });
    if (!body) return;
    if (cart.item_count === 0) {
      body.innerHTML = '<div class="cart-empty"><p class="h3">Your cart is empty</p><p class="muted">Time to find your one-of-a-kind piece.</p><a class="btn btn--accent mt-1" href="/collections/all">Shop all</a></div>';
      if (foot) foot.hidden = true;
      return;
    }
    if (foot) foot.hidden = false;
    body.innerHTML = cart.items.map((item) => `
      <div class="cart-line" data-key="${item.key}">
        <img src="${item.image ? item.image.replace(/(\.[a-z]+)(\?|$)/, "_120x$1$2") : ""}" alt="" width="72" height="72" loading="lazy">
        <div>
          <a class="cart-line__title" href="${item.url}">${item.product_title}</a>
          ${item.variant_title && item.variant_title !== "Default Title" ? `<div class="cart-line__variant">${item.variant_title}</div>` : ""}
          ${renderProperties(item.properties)}
          <div class="qty" data-qty>
            <button type="button" data-step="-1" aria-label="Decrease quantity">−</button>
            <input type="text" inputmode="numeric" value="${item.quantity}" data-line-qty aria-label="Quantity">
            <button type="button" data-step="1" aria-label="Increase quantity">+</button>
          </div>
          <button class="cart-line__remove" data-remove>Remove</button>
        </div>
        <div class="cart-line__price">${money(item.final_line_price)}</div>
      </div>`).join("");
    const totalEl = document.querySelector("[data-cart-total]");
    if (totalEl) totalEl.textContent = money(cart.total_price);
  }

  async function fetchCart() {
    const res = await fetch("/cart.js", { headers: { Accept: "application/json" } });
    return res.json();
  }

  async function changeLine(key, quantity) {
    const res = await fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: key, quantity }),
    });
    return res.json();
  }

  document.addEventListener("click", async (e) => {
    const line = e.target.closest(".cart-line");
    if (!line) return;
    const key = line.dataset.key;
    if (e.target.matches("[data-remove]")) {
      const cart = await changeLine(key, 0);
      renderCart(cart);
    }
    if (e.target.matches("[data-step]")) {
      const input = line.querySelector("[data-line-qty]");
      const next = Math.max(0, parseInt(input.value, 10) + parseInt(e.target.dataset.step, 10));
      const cart = await changeLine(key, next);
      renderCart(cart);
    }
  });

  /* ---------- Add to cart forms ---------- */
  document.querySelectorAll("form[data-product-form]").forEach((form) => {
    form.addEventListener("submit", async (e) => {
      e.preventDefault();
      const btn = form.querySelector("[data-add-btn]");
      const original = btn ? btn.textContent : "";
      if (btn) { btn.disabled = true; btn.textContent = "Adding…"; }
      try {
 // Serialize the ENTIRE form so app-injected fields (King Product
        // Options → properties[...]) are included.
        const formData = new FormData(form);
        // Drop internal option-N radios; the hidden [name='id'] input
        // already carries the resolved variant.
        Array.from(formData.keys())
          .filter((k) => /^option-\d+$/.test(k))
          .forEach((k) => formData.delete(k));
        const res = await fetch("/cart/add.js", {
          method: "POST",
          headers: { Accept: "application/json" },
          body: formData,
        });
        if (!res.ok) throw new Error("add failed");
        const cart = await fetchCart();
        renderCart(cart);
        if (cartDrawer) cartDrawer.open();
        if (btn) btn.textContent = "Added ✓";
      } catch (err) {
        if (btn) btn.textContent = "Try again";
      } finally {
        setTimeout(() => { if (btn) { btn.disabled = false; btn.textContent = original; } }, 1400);
      }
    });
  });

  // Initial cart sync
  fetchCart().then(renderCart).catch(() => {});

  /* ---------- Product variants ---------- */
  document.querySelectorAll("[data-variant-root]").forEach((root) => {
    let variants = [];
    try { variants = JSON.parse(root.querySelector("[data-variant-json]").textContent); } catch (e) {}
    const idInput = root.querySelector("[name='id']");
    const priceEl = root.querySelector("[data-pdp-price]");
    const addBtn = root.querySelector("[data-add-btn]");
    function selectedOptions() {
      return Array.from(root.querySelectorAll("[data-option]")).map((g) => {
        const checked = g.querySelector("input:checked");
        return checked ? checked.value : (g.querySelector("select") ? g.querySelector("select").value : null);
      });
    }
    function update() {
      const opts = selectedOptions();
      const match = variants.find((v) => v.options.every((o, i) => o === opts[i]));
      if (!match) return;
      idInput.value = match.id;
      if (priceEl) {
        priceEl.innerHTML = match.compare_at_price && match.compare_at_price > match.price
          ? `<span class="price__sale">${money(match.price)}</span> <span class="price__compare">${money(match.compare_at_price)}</span>`
          : money(match.price);
      }
      if (addBtn) {
        if (match.available) { addBtn.disabled = false; addBtn.textContent = "Add to cart"; }
        else { addBtn.disabled = true; addBtn.textContent = "Sold out"; }
      }
    }
    root.addEventListener("change", (e) => { if (e.target.matches("[data-option] input, [data-option] select")) update(); });
    update();
  });

  /* ---------- Product gallery ---------- */
  document.querySelectorAll("[data-gallery]").forEach((g) => {
    const main = g.querySelector("[data-gallery-main] img");
    g.querySelectorAll("[data-thumb]").forEach((t) => {
      t.addEventListener("click", () => {
        main.src = t.dataset.full;
        main.alt = t.querySelector("img").alt;
        g.querySelectorAll("[data-thumb]").forEach((x) => x.setAttribute("aria-current", "false"));
        t.setAttribute("aria-current", "true");
      });
    });
  });

  /* ---------- Carousels ---------- */
  document.querySelectorAll("[data-carousel]").forEach((c) => {
    const track = c.querySelector("[data-carousel-track]");
    c.querySelectorAll("[data-carousel-btn]").forEach((b) => {
      b.addEventListener("click", () => {
        const dir = b.dataset.carouselBtn === "next" ? 1 : -1;
        track.scrollBy({ left: dir * track.clientWidth * 0.8, behavior: "smooth" });
      });
    });
  });

  /* ---------- Scroll reveal ---------- */
  const io = "IntersectionObserver" in window
    ? new IntersectionObserver((entries) => {
        entries.forEach((en) => { if (en.isIntersecting) { en.target.classList.add("is-in"); io.unobserve(en.target); } });
      }, { threshold: 0.12 })
    : null;
  document.querySelectorAll(".reveal").forEach((el) => (io ? io.observe(el) : el.classList.add("is-in")));

  /* ---------- Slideshow ---------- */
  document.querySelectorAll("[data-slideshow]").forEach((root) => {
    const track = root.querySelector("[data-slides]");
    const slides = root.querySelectorAll("[data-slide]");
    const dots = root.querySelectorAll("[data-slide-dot]");
    if (slides.length < 2) return;
    let i = 0;
    let timer;
    function go(n) {
      i = (n + slides.length) % slides.length;
      track.style.transform = `translateX(-${i * 100}%)`;
      dots.forEach((d, k) => d.setAttribute("aria-current", k === i ? "true" : "false"));
    }
    function auto() { timer = setInterval(() => go(i + 1), 6000); }
    function stop() { clearInterval(timer); }
    root.querySelector("[data-slide-next]")?.addEventListener("click", () => { go(i + 1); stop(); auto(); });
    root.querySelector("[data-slide-prev]")?.addEventListener("click", () => { go(i - 1); stop(); auto(); });
    dots.forEach((d) => d.addEventListener("click", () => { go(parseInt(d.dataset.slideDot, 10)); stop(); auto(); }));
    root.addEventListener("mouseenter", stop);
    root.addEventListener("mouseleave", auto);
    auto();
  });

  /* ---------- Collection sort ---------- */
  document.querySelectorAll("[data-sort]").forEach((sel) => {
    sel.addEventListener("change", () => {
      const url = new URL(window.location.href);
      url.searchParams.set("sort_by", sel.value);
      window.location.href = url.toString();
    });
  });
})();
